<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        icon="mdi-chat"
        variant="flat"
        size="x-large"
        class="chat-button bg-indigo"
      />
    </template>

    <v-card class="ma-2" max-width="400">
      <v-card-title>Chat</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div class="chat-window">
          <template v-for="msg in messages">
            <div
              :class="{'justify-end': msg.from === 'me', 'justify-start': msg.from !== 'me'}"
              class="d-flex mb-3"
            >
              <v-avatar
                v-if="msg.from !== 'me'"
                color="indigo"
                variant="outlined"
                class="mr-2"
              >
                {{ msg.from.charAt(0) }}
              </v-avatar>
              <v-card
                :variant="msg.from !== 'me' ? 'outlined' : 'flat'"
                style="width: 80%"
                color="indigo"
                class="pa-2 rounded"
              >
                <span>{{ msg.message }}</span>
                <br>
                <small class="text-muted">{{ msg.time }}</small>
              </v-card>
            </div>
          </template>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-textarea
          v-model="newMessage"
          label="Ketik pesan"
          row-height="15"
          rows="1"
          color="indigo"
          append-icon="mdi-send-outline"
          auto-grow
          @click:append="sendMessage"
        />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      messages: [
        {
          from: "me",
          message: "Sure, see you later.",
          time: "10:42am",
          color: "indigo lighten-1",
        },
        {
          from: "John Doe",
          message: "Yeah, sure. Does 1:00pm work?",
          time: '10:37am',
          color: 'green',
        },
        {
          from: "John Doe",
          message: "Combining an avatar with other components allows you to build beautiful user interfaces right out of the box.",
          time: '10:37am',
          color: 'green',
        },
      ],
      newMessage: "",
    };
  },
  methods: {
    sendMessage() {
      if (this.newMessage.trim() !== "") {
        this.messages.push({
          message: this.newMessage,
          from: "me"
        });
        this.messages.push({
          message: this.newMessage,
          from: "other"
        });
        this.newMessage = "";
      }
    },
  },
};
</script>